export default __webpack_public_path__ + "static/media/tokensPromoDark.e717f871.png";